// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import "./Signup.css";

// const Signup = () => {
//   const navigate = useNavigate();
//   const handleLoginRedirect = () => {
//     navigate("/Login");
//   };
//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [userName, setUsername] = useState("");
//   const [password, setPassword] = useState("");

//   return (
//     <>
//       <div className="SignupPage">
//         <div className="container">
//           <div className="center">
//             <h1>Register</h1>
//             <form method="POST" action="">
//               <div className="txt_field">
//                 <input
//                   type="text"
//                   name="name"
//                   required=""
//                   onChange={(event) => {
//                     setName(event.target.value);
//                   }}
//                 />
//                 <span />
//                 <label>Name</label>
//               </div>
//               <div className="txt_field">
//                 <input
//                   type="email"
//                   name="email"
//                   required=""
//                   onChange={(event) => {
//                     setEmail(event.target.value);
//                   }}
//                 />
//                 <span />
//                 <label>Email</label>
//               </div>
//               <div className="txt_field">
//                 <input
//                   type="password"
//                   name="password"
//                   required=""
//                   onChange={(event) => {
//                     setPassword(event.target.value);
//                   }}
//                 />
//                 <span />
//                 <label>Password</label>
//               </div>
//               {/* <div className="txt_field">
//                 <input type="password" name="cpassword" required="" />
//                 <span />
//                 <label>Confirm Password</label>
//               </div> */}
//               <input name="submit" type="Submit" defaultValue="Sign Up" />
//               <div className="signup_link">
//                 Have an Account ?{" "}
//                 <Link onClick={handleLoginRedirect}>Login Here</Link>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Signup;

import React from 'react'

const Signup = () => {
  return (
    <div>
      
    </div>
  )
}

export default Signup

